import { render } from "./PlanItem.vue?vue&type=template&id=55135baa&scoped=true"
import script from "./PlanItem.vue?vue&type=script&lang=js"
export * from "./PlanItem.vue?vue&type=script&lang=js"

import "./PlanItem.vue?vue&type=style&index=0&id=55135baa&lang=scss&scoped=true"

import exportComponent from "E:\\uni-app项目\\kxsns-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55135baa"]])

export default __exports__